// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. See full license in the root of the repo.
/*
    This file provides the provides functionality to get Microsoft Graph data.
*/

//clientside

export async function callMiddleTier(
  middletierToken: string,
  endpoint: string,
  method: "GET" | "POST" = "GET",
  jsonBody?: string
): Promise<any> {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();

    xhr.open(method, endpoint, true);
    xhr.setRequestHeader("Authorization", "Bearer " + middletierToken);
    xhr.setRequestHeader("Cache-Control", "no-cache");

    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          // success case
          try {
            var response = JSON.parse(xhr.responseText);
            resolve(response);
          } catch (error) {
            let errorMessage = "Error parsing response: " + xhr.responseText;
            reject(errorMessage);
          }
        } else {
          // error case
          let errorMessage = `Error from middle tier. \n${xhr.responseText}`;
          reject(errorMessage);
        }
      }
    };

    xhr.onerror = function () {
      let errorMessage = "Network error or permission denied.";
      reject(errorMessage);
    };
    // if post, set content type and send body, else just send
    if (method === "POST") {
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(jsonBody);
    } else xhr.send();
  });
}
